document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-gallery__media').forEach(function (mediaItem) {
    const zoomButton = mediaItem.querySelector('button[is="product-zoom-button"]');
    const image = mediaItem.querySelector('img');

    if (image && zoomButton) {
      image.style.cursor = 'zoom-in';
      image.addEventListener('click', function () {
        zoomButton.click();
      });
    }
  });
});
